import { PROP_TYPE_HINT, type PropTypeHint } from "@/src/shared_modules/custom_elements/types/customElements";

export const LIGHT_BOX_PROP_TYPES: Record<string, PropTypeHint> = {
  open: PROP_TYPE_HINT.Boolean,
  activeIndex: PROP_TYPE_HINT.Number,
};

export const FIELDSET_PROP_TYPES: Record<string, PropTypeHint> = {
  required: PROP_TYPE_HINT.Boolean,
  disabled: PROP_TYPE_HINT.Boolean,
  hiddenLabel: PROP_TYPE_HINT.Boolean,
  withDivider: PROP_TYPE_HINT.Boolean,
  removable: PROP_TYPE_HINT.Boolean,
  withBorder: PROP_TYPE_HINT.Boolean,
  collapsible: PROP_TYPE_HINT.Boolean,
  expanded: PROP_TYPE_HINT.Boolean,
};

export const DIALOG_PROP_TYPES: Record<string, PropTypeHint> = {
  open: PROP_TYPE_HINT.Boolean,
  closeable: PROP_TYPE_HINT.Boolean,
  absolute: PROP_TYPE_HINT.Boolean,
};
